module.exports = __webpack_public_path__ + "img/top4.3d21e850.png";